import { TABLE_TYPES } from '../../tableTypes';
import { SECTION_1_TABLE_NAMES_V1 as SECTION_1_TABLE_NAMES } from '../tableNames';

export const SECTION_1_TABLES = {
  [SECTION_1_TABLE_NAMES.FILING_TYPE]: {
    questionLevels: [
      {
        columns: {
          filing_type: { name: 'Filing type', disabled: true },
          reporting_period: { name: 'Reporting period', disabled: true },
          reporting_period_end_date: { name: 'Reporting period end date', disabled: true }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.AIFM_FILING_TYPE]: {
    questionLevels: [
      {
        columns: {
          filing_type: { name: 'Filing type', disabled: true },
          reporting_period: { name: 'Reporting period', disabled: true },
          reporting_period_end_date: { name: 'Reporting period end date', disabled: true }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.IDENT_INFO]: {
    questionLevels: [
      {
        name: 'Provide your name and the other identifying information requested below.',
        level: '(a)',
        columns: {
          legal_name: { name: 'Legal Name', disabled: true },
          sec_801_number: { name: 'SEC 801-Number', disabled: true },
          nfa_id: { name: 'NFA ID Number, if any', disabled: true },
          large_trader_id: { name: 'Large trader ID, if any', disabled: true },
          large_trader_sffx: { name: 'Large trader ID suffix, if any', disabled: true }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.RELATED_PERSONS]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'Provide the following information for each of the related persons, if any, with respect to which you are reporting information on this Form PF:',
        level: '(b)',
        columns: {
          legal_name: { name: 'Legal Name' },
          sec_801_number: { name: 'SEC 801-Number' },
          nfa_id: { name: 'NFA ID Number, if any' },
          large_trader_id: { name: 'Large trader ID, if any' },
          large_trader_sffx: { name: 'Large trader ID suffix, if any' }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.FUND_INFO]: {
    questionLevels: [
      {
        columns: {
          fund_name: { name: 'Name of the reporting fund', level: '(a)', disabled: true },
          fund_id_field: {
            name: 'Private fund identification number of the reporting fund',
            level: '(b)',
            disabled: true
          },
          nfa_id: {
            name: 'NFA identification number of the reporting fund, if applicable',
            level: '(c)',
            disabled: true
          },
          legal_entity_id: {
            name: 'LEI of the reporting fund, if applicable',
            level: '(d)',
            disabled: true
          }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.MASTER_FEEDER_ARRANGEMENT]: {
    questionLevels: [
      {
        columns: {
          is_master_fund: {
            name: 'Is master fund?'
          }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.PARALLEL_FUNDS]: {
    questionLevels: [
      {
        columns: {
          maybe_subjected_to_material_restrictions: {
            name: 'Is aggregated parallel fund?',
            level: '(a)'
          }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.PARALLEL_FUND_DETAILS]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'If you responded “yes” to Question 7(a), complete (b) through (e) below for each other parallel fund in the parallel fund structure.',
        columns: {
          name: { name: 'Name of the parallel fund', level: '(b)' },
          fund_id_field: {
            name: 'Private fund identification number',
            level: '(c)'
          },
          legal_entity_id: {
            name: 'LEI of the parallel fund, if applicable.',
            level: '(d)'
          },
          nfa_id: {
            name: 'NFA identification number',
            level: '(e)'
          }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.GROSS_ASSET]: {
    questionLevels: [
      {
        columns: {
          gross_asset_value: { name: 'Gross asset value of reporting fund.' }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.NET_ASSET]: {
    questionLevels: [
      {
        columns: {
          net_asset_value: { name: 'Net asset value of reporting fund' }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.EQUITY_VALUE_OTHER_FUNDS]: {
    questionLevels: [
      {
        columns: {
          equity_value_in_other_funds: {
            name: 'Value in equity of other private funds'
          }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.PARALLEL_MANAGED_ACCOUNTS]: {
    questionLevels: [
      {
        columns: {
          parallel_managed_accounts_value: {
            name: 'Value of parallel managed accounts'
          }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.BORROWINGS_AND_OTHER_CREDITORS]: {
    questionLevels: [
      {
        name: "Provide the following information regarding the value of the reporting fund's borrowings and the types of creditors.",
        columns: {
          borrowed_total_amount: {
            name: 'Dollar amount of total borrowings',
            level: '(a)'
          },
          percentage_us_depository_institution: {
            name: '% borrowed from U.S. financial institutions',
            level: '(b)'
          },
          percentage_us_non_depository_institution: {
            name: '% borrowed from non-U.S. financial institutions',
            level: '(c)'
          },
          percentage_us_creditors: {
            name: '% borrowed from U.S. non-financial institutions',
            level: '(d)'
          },
          percentage_non_us_creditors: {
            name: '% borrowed from non-U.S. non-financial institutions .',
            level: '(e)'
          }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.OUTSTANDING_DERIVATIVES]: {
    questionLevels: [
      {
        columns: {
          has_outstanding_derivatives_positions: {
            name: 'Does the fund have any derivatives positions?',
            level: '(a)'
          },
          aggregate_derivatives_positions_value: {
            name: 'Aggregate value of all derivatives positions',
            level: '(b)'
          }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.FUND_ASSETS_AND_LIABILITIES_VALUE]: {
    type: TABLE_TYPES.RANKING_TABLE,
    questionLevels: [
      {
        name: "Provide a summary of the reporting fund's assets and liabilities categorized using the hierarchy below. For assets and liabilities that you report internally and to current and prospective investors as representing fair value, or for which you are required to determine fair value in order to report the reporting fund's regulatory assets under management on Form ADV, categorize them into the following categories based on the valuation assumptions utilized:",
        columns: {
          ranking: {
            conditions: { 0: 'Assets', 1: 'Liabilities' }
          },
          fair_value_level1_assets_value: {
            name: 'Level 1'
          },
          fair_value_level2_assets_value: {
            name: 'Level 2'
          },
          fair_value_level3_assets_value: {
            name: 'Level 3'
          },
          cost_based_assets_value: {
            name: 'Cost-based'
          }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.BENEFICIALLY_OWNED_EQUITY_BY_TOP5_OWNERS]: {
    questionLevels: [
      {
        columns: {
          beneficially_owned_equity_by_top5_owners: {
            name: '% of equity owned by the top five beneficial owners'
          }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.BENEFICIALLY_OWNED_EQUITY_INVESTORS]: {
    type: TABLE_TYPES.TURNOVER,
    groupColumn: 'sub_asset_type',
    rankLevels: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n'],
    questionLevels: [
      {
        name: "Specify the approximate percentage of the reporting fund's equity that is beneficially owned by the following groups of investors.",
        columns: {
          value: {
            name: 'Value'
          }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.GROSS_NET_PERFORMANCE]: {
    type: TABLE_TYPES.RANKING_TABLE,
    rankLevels: [
      '(a)',
      '(b)',
      '(c)',
      '(d)',
      '(e)',
      '(f)',
      '(g)',
      '(h)',
      '(i)',
      '(j)',
      '(k)',
      '(l)',
      '(m)',
      '(n)',
      '(o)',
      '(p)',
      '(q)'
    ],
    questionLevels: [
      {
        name: "Provide the reporting fund's gross and net performance, as reported to current and prospective investors (or, if calculated for other purposes but not reported to investors, as so calculated). If the fund reports different performance results to different groups of investors, provide the most representative results. You are required to provide monthly and quarterly performance results only if such results are calculated for the reporting fund (whether for purposes of reporting to current or prospective investors or otherwise).",

        columns: {
          ranking: {
            name: 'Month',
            conditions: {
              2: 'Month',
              3: 'First Quarter',
              6: 'Month',
              7: 'Second Quarter',
              10: 'Month',
              11: 'Third Quarter',
              14: 'Month',
              15: 'Fourth Quarter',
              16: 'Year'
            }
          },
          not_applicable: { name: 'Not Applicable' },
          end_date: { name: 'End Date' },
          gross_performance: { name: 'Gross Performance' },
          net_performance: { name: 'Net Performance' }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.STRATEGY_TYPE]: {
    questionLevels: [
      {
        columns: {
          strategy_type: {
            name: 'Single or multiple strategies?'
          }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.STRATEGY_HIGH_FREQUENCY]: {
    questionLevels: [
      {
        columns: {
          strategy_high_frequency_trading_percent: {
            name: '% of NAV managed using high-frequency strategies?'
          }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.TRADING_AND_CLEARING]: {
    questionLevels: [
      {
        name: ' Estimated % (in terms of value) of securities (other than derivatives) that were traded by the reporting fund:',
        level: '(a)',
        columns: {
          sec_reg_exch_percent: { name: 'On a regulated exchange ' },
          sec_otc_percent: { name: 'OTC' }
        }
      },
      {
        name: 'Estimated % (in terms of trade volumes) of derivatives that were traded by the reporting fund:',
        level: '(b)',
        columns: {
          der_reg_exch_percent: { name: 'On a regulated exchange or swap execution facility' },
          der_otc_percent: { name: 'OTC' }
        }
      },
      {
        name: 'Estimated % (in terms of trade volumes) of derivatives that were traded by the reporting fund and:',
        level: '(c)',
        columns: {
          der_otc_ccp_cleared_percent: { name: 'Cleared by a CCP' },
          der_otc_not_ccp_clear_percent: {
            name: 'Bilaterally transacted (i.e., not CCP)'
          }
        }
      },
      {
        name: 'Estimated % (in terms of value) of repo trades that were entered into by the reporting fund and:',
        level: '(d)',
        columns: {
          repo_ccp_cleared_percent: { name: 'Cleared by a CCP' },
          repo_not_ccp_cleared_percent: {
            name: 'Bilaterally transacted (i.e., not CCP)'
          },
          repo_tri_repo_percent: {
            name: 'Tri-party repo'
          }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.OTHER_TRANSACTION_PERCENT]: {
    questionLevels: [
      {
        columns: {
          other_transaction_percent: {
            name: "What percentage of the reporting fund's net asset value relates to transactions that are not described in any of the categories listed in items (a) through (d) of Question 24?"
          }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.STRATEGY_TYPE_NET_ASSET_VALUE_CAPITAL_ITEM]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: "Indicate which of the investment strategies in the drop-down menu below best describe the reporting fund's strategies on the last day of the reporting period. For each strategy that you have selected, provide a good faith estimate of the percentage of the reporting fund's net asset value represented by that strategy. If, in your view, the reporting fund's allocation among strategies is appropriately represented by the percentage of deployed capital, you may also provide that information.",
        columns: {
          strategy_type: { name: 'Strategy' },
          percentage_net_asset_value: { name: '% of NAV(required)' },
          percentage_capital: { name: '% of capital(optional)' }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.COUNTERPARTIES_PERCENT]: {
    type: TABLE_TYPES.RANKING_TABLE,
    rankLevels: ['a', 'b', 'c', 'd', 'e'],
    questionLevels: [
      {
        name: "Identify the five counterparties to which the reporting fund has the greatest mark-to- market net counterparty credit exposure, measured as a percentage of the reporting fund's net asset value.",
        columns: {
          counter_party_legal_name: {
            name: 'Legal name of the counterparty'
          },
          affiliated_institution_code: {
            name: 'Affiliated major financial institution'
          },
          affiliated_institution_other_name: {
            name: 'Other'
          },
          counterparty_exposure: {
            name: 'Exposure (% of NAV)'
          }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.COUNTERPARTIES_DOLLAR]: {
    type: TABLE_TYPES.RANKING_TABLE,
    rankLevels: ['a', 'b', 'c', 'd', 'e'],
    questionLevels: [
      {
        name: 'Identify the five counterparties that have the greatest mark-to-market net counterparty credit exposure to the reporting fund, measured in U.S. dollars.',
        columns: {
          counter_party_legal_name: {
            name: 'Legal name of the counterparty'
          },
          affiliated_institution_code: {
            name: 'Affiliated major financial institution'
          },
          affiliated_institution_other_name: { name: 'Other' },
          counterparty_exposure: { name: 'Exposure (in U.S. dollars)' }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.REPRESENTATIVE_SIGNATURE]: {
    questionLevels: [
      {
        name: 'Signature on behalf of the firm and its related persons',
        columns: {
          name: { name: 'Name of individual' },
          signature: { name: 'Signature' },
          signature_title: { name: 'Title' },
          email: { name: 'Email address' },
          phone_number: {
            name: 'Telephone contact number (inc. area code and non-US country code)'
          },
          signature_date: { name: 'Date' }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.RELATED_PERSONS_SIGNATURE]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'Signature on behalf of related persons',
        columns: {
          name: { name: 'Name of individual' },
          signature: { name: 'Signature' },
          signature_title: { name: 'Title' },
          email: { name: 'Email address' },
          phone_number: {
            name: 'Telephone contact number (inc. area code and non-US country code)'
          },
          signature_date: { name: 'Date' }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.AGGREGATED_ASSETS]: {
    type: TABLE_TYPES.TURNOVER,
    groupColumn: 'fund_type',
    questionLevels: [
      {
        columns: {
          regulatory_assets_under_management: {
            name: 'Regulatory assets under management'
          },
          net_assets_under_management: { name: 'Net assets under management' }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.EXPLANATION]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'You may use the space below to explain any assumptions that you made in responding to any question in this Form PF.',
        columns: {
          question_number: { name: 'Question number' },
          description: { name: 'Description' }
        }
      }
    ]
  },
  [SECTION_1_TABLE_NAMES.FUND_IDENTIFYING_INFORMATION_Q18]: {
    questionLevels: [
      {
        columns: {
          fund_name: { name: 'Name of the reporting fund ', level: '(a)' },
          fund_id_field: {
            name: 'Private fund identification number',
            level: '(b)'
          }
        }
      }
    ]
  }
};
